import { useState,useEffect } from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { Card, CardContent, Grid, Box, TextField, Rating } from '@mui/material'
import { ThemeProvider,createTheme } from '@mui/material'
import Button from '../../components/Button'
import { post } from '../../utils/axios'
import { toast } from 'react-toastify'

import './Poll.css'

const Poll = () => {

    const navigate = useNavigate()
    const {pollId,serviceConsumerId} = useParams()

    const [dataIsLoading,setDataIsLoading] = useState(true)
    const [isLoading,setIsLoading] = useState(false)
    const [opinion,setOpinion] = useState({})
    const [answers,setAnswers] = useState([])
    const [comments,setComments] = useState('')

    useEffect(() => {
        const postedData = {
            token: pollId
        }
        post('Question/GetByToken',postedData).then(({ data }) => {
            if(data.isSuccess)
                setOpinion(data.data)
        }).finally(() => setDataIsLoading(false))
    },[])

    // const answerQuestion = (e,questionId,answerWeight) => {
    //     let stars = document.getElementsByClassName(`raiting-emojie-${questionId}`);
    //     for(let i = 0;i < stars.length;i++)
    //         if(typeof stars[i] === 'object')
    //             stars[i].classList.remove('active');
    //     e.currentTarget.classList.add('active');
    //     let oldAnswers = answers;
    //     let hasAnswer = oldAnswers.findIndex(answer => answer.questionId == questionId);
    //     if(hasAnswer >= 0){
    //         oldAnswers[hasAnswer].answerWeight = answerWeight;
    //         oldAnswers[hasAnswer].serviceConsumerId = parseInt(serviceConsumerId);
    //     }else
    //         oldAnswers.push({
    //             questionId,
    //             serviceConsumerId: parseInt(serviceConsumerId),
    //             answerWeight
    //         });
    //     setAnswers(old => [...oldAnswers]);
    // }

    const answerQuestion = (questionId,answerWeight) => {
        let oldAnswers = [...answers];
        let hasAnswer = oldAnswers.findIndex(answer => answer.questionId == questionId);
        if(hasAnswer >= 0){
            oldAnswers[hasAnswer].answerWeight = answerWeight;
            oldAnswers[hasAnswer].serviceConsumerId = parseInt(serviceConsumerId);
        }else
            oldAnswers.push({
                questionId,
                serviceConsumerId: parseInt(serviceConsumerId),
                answerWeight
            });
        setAnswers(old => [...oldAnswers]);
    }

    const submitVote = () => {
        setIsLoading(true)
        const postedData = {
            token: pollId,
            ans: answers,
            comments
        };
        post('Answer/AddAnswer',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success('نظر شما با موفقیت ثبت شد')
                navigate(-1)
            }else
                toast.error('خطایی در ثبت نظر رخ داده است')
        }).catch(() => {
            toast.error('خطایی در ثبت نظر رخ داده است')
        }).finally(() => {
            setIsLoading(false)
        });
    }

    const theme = createTheme({
        direction: 'ltr'
    })


    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">شرکت در نظرسنجی</h3>
            <div className="safe-area">
                <Box sx={{mb: 5}}>
                    <Card sx={{width: '100%',mb: 2}}>
                        {!dataIsLoading ? (Object.keys(opinion).length ? <>
                            <CardContent sx={{pb: 0}} id="poll-data">
                                <img src={`${opinion.logo ? 'data:image/jpeg;base64,' : ''}${opinion.logo}`} />
                                <p id="poll-description">همکار گرامی شما از مجموعه <span>{opinion.businessTitle}</span> استفاده نموده اید. لطفاً با ثبت نظر خود ما را در امر بهبود خدمات یاری نمایید.</p>
                                {opinion.result?.map(question => (
                                    <div className="question" key={question.id}>
                                        <h4>{question.title}</h4>
                                        <div dir="ltr" style={{textAlign: 'center',marginTop: '10px'}}>
                                            <ThemeProvider theme={theme}>
                                                <Rating max={10} onChange={(e,value) => answerQuestion(question.id,value)} />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                ))}
                                <TextField fullWidth label="انتقادات و پیشنهادات" multiline rows={4} variant="standard" onChange={e => setComments(e.target.value)} />
                                <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 3,py: 1.5}} className="custom-btn-primary" variant="contained" onClick={submitVote}>ثبت نظر</Button>
                            </CardContent>
                        </> : <p id="poll-loading">خطایی در پردازش رخ داده است ...</p>) : <p id="poll-loading">در حال بارگذاری ...</p>}
                    </Card>
                </Box>
            </div>
        </Grid>
    )
}

export default Poll